export const FILTER_TYPES_MASTER = {
  MASTER: "master",
  PARAMETERS: "parameters"
} as const;

export type MasterFilter =
  | { 
      type: typeof FILTER_TYPES_MASTER.MASTER; 
      codigosTablas?: string;
      codigoPais?: number;
    }
  | { type: typeof FILTER_TYPES_MASTER.PARAMETERS }